import mutations from './weekyPatient.mutations'
import actions from './weeklyPatient.actions'
import getters from './weeklyPatient.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
